
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RealisatiesPage = lazy(() => import('../pages/realisaties/page'));
const DienstenPage = lazy(() => import('../pages/diensten/page'));
const DienstenSmartphonePage = lazy(() => import('../pages/diensten-smartphone/page'));
const DienstenInterieurPage = lazy(() => import('../pages/diensten-interieur/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/over-ons',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/realisaties',
    element: <RealisatiesPage />,
  },
  {
    path: '/diensten',
    element: <DienstenPage />,
  },
  {
    path: '/diensten/smartphone-multimedia',
    element: <DienstenSmartphonePage />,
  },
  {
    path: '/diensten/sterrenhemel-sfeerverlichting-achteruitcamera-in-antwerpen',
    element: <DienstenInterieurPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
